<button class="button-icon button-icon--th-ctrl" (click)="onOpenModal()">
  <i class="icomoon icomoon--menu"></i>
</button>

<div *ngIf="isShowModal" appModalSwipe
     class="modal l-wrapper"
     [ngClass]="{'modal--mobile _left-direction': breakPoint.isMobile}">
  <div class="modal__overlay" appOverlaySwipe (click)="isShowModal = false"></div>
  <div class="modal__container" appBottomSwipeSheet (swipeAnimationEnd)="onCloseModal()" direction="right">

    <div class="modal__head l-wrapper">
      <div class="logo"  *ngIf="logoUrl$ | async as logoUrl; else defaultLogo">
        <picture class="cover-picture">
          <img ngSrc="{{ logoUrl }}" alt="logo" width="250" height="100">
        </picture>
      </div>

      <div class="modal__right">
        <button type="button" class="button_close button_close-round" (click)="onCloseModal()">
          <i class="icomoon icomoon--close"></i>
        </button>
      </div>
    </div>

    <div class="modal__content">
      <div class="modal__body l-wrapper">
        <nav class="nav">
          <div class="nav__item" *ngIf="pageAbout$ | async as pageAbout">
            <a [routerLink]="['additional', pageAbout.slug]" class="nav-link link" (click)="onRedirect()">
              <div class="nav-link__icon"><i class="icomoon icomoon--info"></i></div>
              <span class="nav-link__text">{{ pageAbout.menuLabel }}</span>
              <span class="nav-link__right"><i class="icomoon icomoon--caret-right"></i></span>
            </a>
          </div>

          <div class="nav__item" *ngIf="pagePromoActions$ | async" routerLink="/actions">
            <a [routerLink]="['actions']" class="nav-link link" (click)="onRedirect()">
              <div class="nav-link__icon"><i class="icomoon icomoon--promo-filled"></i></div>
              <span class="nav-link__text" i18n="@@PromotionActions">Promotion actions</span>
              <span class="nav-link__right"><i class="icomoon icomoon--caret-right"></i></span>
            </a>
          </div>

          <ng-container *ngIf="(customerProfile$ | async) && (isBasketMode$ | async)">
            <div class="nav__item">
              <a [routerLink]="['customer-area', 'profile']" class="nav-link link" (click)="onRedirect()">
                <div class="nav-link__icon"><i class="icomoon icomoon--user"></i></div>
                <span class="nav-link__text" i18n="@@MyDetails">Account data</span>
                <span class="nav-link__right"><i class="icomoon icomoon--caret-right"></i></span>
              </a>
            </div>

            <div class="nav__item">
              <a [routerLink]="['customer-area', 'orders']" class="nav-link link" (click)="onRedirect()">
                <div class="nav-link__icon"><i class="icomoon icomoon--history"></i></div>
                <span class="nav-link__text" i18n="@@Orders">Orders</span>
                <span class="nav-link__right"><i class="icomoon icomoon--caret-right"></i></span>
              </a>
            </div>
          </ng-container>

          <div class="nav__item" *ngFor="let page of additionalPages$ | async">
            <a [routerLink]="['additional', page.slug]" class="nav-link link" (click)="onRedirect()">
              <div class="nav-link__icon"><i class="icomoon icomoon--menu"></i></div>
              <span class="nav-link__text">{{ page.menuLabel }}</span>
              <span class="nav-link__right"><i class="icomoon icomoon--caret-right"></i></span>
            </a>
          </div>

          <div class="nav__item" *ngIf="(customerProfile$ | async) === null && (isBasketMode$ | async) && (isLoyalty$ | async)">
            <button class="nav-link link" (click)="isShowAuth = true" type="button">
              <div class="nav-link__icon"><i class="icomoon icomoon--user"></i></div>
              <span class="nav-link__text" i18n="@@SignInSignUp">Sign in / sign up</span>
              <span class="nav-link__right"><i class="icomoon icomoon--caret-right"></i></span>
            </button>
          </div>

          <div class="nav__item">
            <app-lang-switch>
              <button class="nav-link link" type="button" appLangSwitchToggle>
                <div class="nav-link__icon"><i class="icomoon icomoon--planet"></i></div>
                <span class="nav-link__text" appLangSwitchText></span>
                <span class="nav-link__right"><i class="icomoon icomoon--caret-right"></i></span>
              </button>
            </app-lang-switch>
          </div>
        </nav>
      </div>

      <div class="modal__footer l-wrapper">
        <div class="footer-item footer-item_link" *ngIf="phone$ | async as phone">
          <a href="tel:{{ phone }}" class="footer-item__phone">{{ phone }}</a>
        </div>
        <div class="footer-item" *ngIf="workingHours$ | async as workingHours">
          <span class="footer-item__schedule" i18n="@@FromTo">from {{ workingHours.open }} to {{ workingHours.close }}</span>
        </div>

        <div class="footer-item" *ngIf="pagePrivacy$ | async as privacyPage">
          <a [routerLink]="['additional', privacyPage.slug]"
             class="link link--th-ctrl link--underline-in"
             i18n="@@PrivacyPolicy"
          >Privacy policy</a>
        </div>

        <div class="footer-item">
          <span class="footer-item__text" i18n="@@FooterCopyright">Developed on the platform</span>&nbsp;
          <span class="footer-item__text">{{ brandName }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultLogo>
  <div class="logo">
    <picture>
      <img ngSrc="./assets/images/default-logo.png" alt="logo" width="162" height="29">
    </picture>
  </div>
</ng-template>

<app-fresh-auth-page *ngIf="isShowAuth" (closeModal)="onCloseAuth()"></app-fresh-auth-page>
